export default __webpack_public_path__ + "static/media/_G.d9435180.png";